import React from 'react';
import { IconButton } from '@chakra-ui/react';
import { FaEdit, FaTimesCircle } from 'react-icons/fa';

import { ICompanyDefaultValue } from '../../../models/DefaultValue';

type Props = {
    data: ICompanyDefaultValue[];
    emptyMessage?: string;
    onClickEdit?: (defaultValue: ICompanyDefaultValue) => void;
    onClickDelete?: (defaultValue: ICompanyDefaultValue) => void;
};

function DefaultValueTable(props: Props) {
    const { data, emptyMessage = 'No Data.', onClickEdit, onClickDelete } = props;

    return (
        <table className="table table-bordered align-middle employee-font font-size-employee">
            <thead>
                <tr className="text-center table-active thead-light">
                    <th style={{ width: '1%', whiteSpace: 'nowrap' }}>Action</th>
                    <th>บริษัท</th>
                    <th>Key</th>
                    <th>Value</th>
                </tr>
            </thead>
            <tbody>
                {data.length === 0 ? (
                    <tr><td colSpan={4} style={{ background: '#b7b7a4', color: 'black', fontSize: '10pt', textAlign: 'center' }}>{emptyMessage}</td></tr>
                ) : (
                    data.map((defaultValue) => (
                        <tr key={defaultValue.sid + defaultValue.key}>
                            <td className="text-center">
                                <div style={{ display: 'flex', gap: '4px' }}>
                                    <IconButton
                                        variant="outline"
                                        colorScheme="blue"
                                        size="sm"
                                        icon={<FaEdit />}
                                        aria-label="Edit"
                                        onClick={() => onClickEdit?.(defaultValue)}
                                    />
                                    <IconButton
                                        variant="outline"
                                        colorScheme="red"
                                        size="sm"
                                        icon={<FaTimesCircle />}
                                        aria-label="Delete"
                                        onClick={() => onClickDelete?.(defaultValue)}
                                    />
                                </div>
                            </td>
                            <td>{defaultValue?.company_name}</td>
                            <td>{defaultValue.key}</td>
                            <td>{defaultValue.value}</td>
                        </tr>
                    ))
                )}
            </tbody>
        </table>
    );
}

export default DefaultValueTable;
